import { FancyShareCreateDto } from '@diritto/common/fancyShare/dtos/fancy-share-edit.dtos';
import { FancyShareResponseDto } from '@diritto/common/fancyShare/dtos/fancy-share.dtos';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { FancyShareApi } from 'api/ApiHelper';

type CreateVariables = { contentId: number; episodeId: number; data: FancyShareCreateDto };

export const useCreateFancyShareMutation = (
  options?: UseMutationOptions<FancyShareResponseDto, unknown, CreateVariables>,
) =>
  useMutation({
    mutationFn: ({ contentId, episodeId, data }: CreateVariables) =>
      FancyShareApi.createFancyShare(contentId, episodeId, data),
    ...options,
  });
